import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import axios from "axios";
import { useApp } from "../../../../services/AppService";
import { API_PATHS } from "../../../../constants";

export function useConnectToken({ onSuccess }: { onSuccess: () => void }) {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { selectedCommunityDocId } = useApp();

  const connectToken = async (tokenAddress: string) => {
    return await axios.post<any>(API_PATHS.tokens.add, {
      tokenAddress,
    });
  };

  return useMutation(
    async ({ tokenAddress }: { tokenAddress: string }) => {
      const { data } = await connectToken(tokenAddress);
      if (!data?.success) {
        throw new Error(`${data?.error?.title}\n${data?.error?.description}`);
      }
      await queryClient.invalidateQueries({
        queryKey: [API_PATHS.tokens.list, selectedCommunityDocId],
        exact: true,
        refetchType: "active",
      });
      return data;
    },

    {
      onSuccess: () => {
        onSuccess();
        enqueueSnackbar({
          variant: "success",
          message: "Token successfully connected!",
        });
      },
      onError: (error: any) => {
        enqueueSnackbar({
          variant: "error",
          message: error?.message || "Oops.. Error on sign in. Try again!",
        });
      },
    }
  );
}
